module.exports = __webpack_public_path__ + "img/accessory_item_07.ceb68a37.svg";